import { IBasePrimaryActionService } from "../IBasePrimaryActionService";
import { Subject } from "rxjs";
import { BFXNotificationType } from "../../model/core/notifications/BFXNotificationType";
import { BFXNotificationSubType } from "../../model/core/notifications/BFXNotificationSubType";
import { ActionEventType } from "../../model/core/ActionEventType";

import * as CubiqTS from "shared/cubiq-model-multi-asset";

export abstract class BasePrimaryActionService implements IBasePrimaryActionService {
  modelUpdateEventPorts: Array<MessagePort> = new Array<MessagePort>();
  modelNotificationFailureEventSubject: Subject<any> = new Subject<any>();
  fireModelNotificationFailureEvent(data: any, additionalData: any = null): void {
    if (data != null) {
      if (additionalData != null) {
        Object.assign(data, additionalData);
      }
      this.modelNotificationFailureEventSubject.next(data);
      this.modelUpdateEventPorts.forEach((port: MessagePort) => {
        try {
          port.postMessage({
            modelEventType: ActionEventType.NOTIFICATION,
            payload: data,
          });
        } catch (ex) {
          console.debug(ex);
        }
      });
    }
  }

  getModelNotificationFailureEventSubject(): Subject<CubiqTS.ConcreteEncodable> {
    return this.modelNotificationFailureEventSubject;
  }

  initModelUpdateService(port: MessagePort): void {
    this.modelUpdateEventPorts.push(port);
  }

  /**
   * If any server request promise is rejected, convert that reject response into an
   * ErrorsImpl if it's not one already
   * @param rejectResponse
   * @returns
   */
  protected createRejectError(rejectResponse: any): CubiqTS.ErrorsImpl {
    let retError: CubiqTS.ErrorsImpl;
    // Convert any promise failure into an error if it's not already one
    if (!(rejectResponse instanceof CubiqTS.ErrorsImpl)) {
      retError = new CubiqTS.ErrorsImpl();
      retError.errorMessages = [
        JSON.stringify({ id: rejectResponse?.toString() ?? "API Error", args: [] }),
      ] as any[];
    } else {
      retError = rejectResponse;
    }
    return retError;
  }

  /**
   * The Notifcation service depends on having the order Ids property on the Error. In case this doesn't come in
   * from the server, we markup the Errors with the specified set of Ids
   * @param response
   * @param orderIds
   */
  protected augmentErrorResultIfNeeded(response, orderIds: string[]) {
    if (response instanceof CubiqTS.ErrorsImpl && response.errorMessages?.length > 0) {
      // only send a notification on errors
      const extendedErrors: any = response;
      if (!(extendedErrors.orderIds?.length > 0)) {
        extendedErrors.orderIds = orderIds.concat();
      }
    }
  }
}
